const registerMetricaEvent = eventId => {
    try {
        window.yaCounter47094159.reachGoal(eventId);
    } catch (e) {
    }
};

export {
    registerMetricaEvent,
};


// WEBPACK FOOTER //
// ./src/utils/metrica.js